import React from "react";
import { useLocation } from "react-router-dom";
import { getTabicubeUrl, isHiroshimaAirport, isSoratabi, modifyHiroshimaParams, modifySoratabiParams } from "./util";

/** 旅CUBEへリダイレクトさせるためのコンポーネント。 */
export const LinkToTabicube: React.FC = () => {
  const location = useLocation();
  /** 現在表示しているページのパス名。 */
  const pathname = location.pathname;
  /** URLパラメーター部分の文字列。 */
  let params = location.search;
  // そらたびページの場合、パラメーターを整形する。
  if (isSoratabi(pathname)) {
    params = modifySoratabiParams(params);
  }
  // 広島空港連携の場合、発着日時のパラメーターを整形する。
  if (isHiroshimaAirport(params)) {
    params = modifyHiroshimaParams(params);
  }
  /** リダイレクト先の旅CUBEのURL。 */
  const tabiCubeUrl = getTabicubeUrl(params);
  window.location.href = tabiCubeUrl;
  return null;
}

export default LinkToTabicube;
